(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  /* ─── OTWS Cart Drawer Enhancements ─── */
  (function () {
    'use strict';

    /* ── Countdown Timer ── */
    function initCountdown() {
      var el = document.getElementById('otws-countdown');
      var timerEl = document.getElementById('otws-countdown-timer');
      if (!el || !timerEl) return;

      var endStr = el.dataset.end;
      if (!endStr) return;

      var endDate = new Date(endStr).getTime();
      if (isNaN(endDate)) return;

      function tick() {
        var now = Date.now();
        var diff = endDate - now;
        if (diff <= 0) {
          timerEl.textContent = '00:00:00';
          el.style.display = 'none';
          return;
        }
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        timerEl.textContent =
          String(h).padStart(2, '0') + ':' +
          String(m).padStart(2, '0') + ':' +
          String(s).padStart(2, '0');
      }

      tick();
      setInterval(tick, 1000);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCountdown);
    } else {
      initCountdown();
    }

    /* Re-init after cart updates (theme event) */
    document.addEventListener('cart:updated', initCountdown);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    return; /* désactivé : remplacé par le script inline en délégation (plus fiable) */

    function initFAQ() {
      var buttons = document.querySelectorAll('.product-faq__question');

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var isOpen = btn.getAttribute('aria-expanded') === 'true';
          var panelId = btn.getAttribute('aria-controls');
          var panel = document.getElementById(panelId);
          if (!panel) return;

          if (isOpen) {
            btn.setAttribute('aria-expanded', 'false');
            panel.hidden = true;
          } else {
            // Optionally close siblings (accordion behavior)
            var section = btn.closest('.product-faq__right');
            if (section) {
              section.querySelectorAll('.product-faq__question[aria-expanded="true"]').forEach(function (other) {
                if (other !== btn) {
                  other.setAttribute('aria-expanded', 'false');
                  var otherId = other.getAttribute('aria-controls');
                  var otherPanel = document.getElementById(otherId);
                  if (otherPanel) otherPanel.hidden = true;
                }
              });
            }
            btn.setAttribute('aria-expanded', 'true');
            panel.hidden = false;
          }
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initFAQ);
    } else {
      initFAQ();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skin-diagnostic-quiz"] && !Shopify.designMode) return;
  try {
    
  (function() {
    'use strict';

    const state = {
      currentStep: 1,
      totalSteps: 6,
      answers: {},
      emailCaptured: false
    };

    const PROFILE_MAP = {
      'seche-antiage':        { title: 'Peau Sèche & Anti-âge',        emoji: '🌿✨', subtitle: 'Votre peau a besoin de nutrition profonde et de régénération cellulaire intense.' },
      'seche-hydratation':    { title: 'Peau Sèche & Déshydratée',      emoji: '💧', subtitle: 'Focus sur la restauration de la barrière cutanée et l\u2019hydratation durable.' },
      'mixte-imperfections':  { title: 'Peau Mixte & Purifiante',       emoji: '☯️🧹', subtitle: 'Équilibre sebum, purification de la zone T et respect des zones sèches.' },
      'grasse-imperfections': { title: 'Peau Grasse & Anti-brillance',  emoji: '💦🧹', subtitle: 'Action ciblée sur la régulation du sébum et la réduction des pores.' },
      'sensible-eclat':       { title: 'Peau Sensible & Lumineuse',     emoji: '🌸☀️', subtitle: 'Formules apaisantes et éclat progressif sans agresser les peaux réactives.' },
      'default':              { title: 'Votre Routine Personnalisée',    emoji: '🌿', subtitle: 'Nous avons sélectionné les soins les plus adaptés à votre profil.' }
    };

    function getProfileKey() {
      const skin = state.answers[1] || '';
      const concern = state.answers[2] || '';
      const key = `${skin}-${concern}`;
      return PROFILE_MAP[key] ? key : 'default';
    }

    function getProfile() {
      return PROFILE_MAP[getProfileKey()];
    }

    function init() {
      const startBtn = document.getElementById('quiz-start-btn');
      if (startBtn) startBtn.addEventListener('click', startQuiz);

      const prevBtn = document.getElementById('quiz-prev-btn');
      if (prevBtn) prevBtn.addEventListener('click', goToPrev);

      const skipEmail = document.getElementById('quiz-skip-email');
      if (skipEmail) skipEmail.addEventListener('click', showResults);

      const restartBtn = document.getElementById('quiz-restart-btn');
      if (restartBtn) restartBtn.addEventListener('click', restartQuiz);

      const addRoutineBtn = document.getElementById('quiz-add-routine-btn');
      if (addRoutineBtn) addRoutineBtn.addEventListener('click', addRoutineToCart);

      document.querySelectorAll('.skin-quiz__option').forEach(function(btn) {
        btn.addEventListener('click', function() {
          const step = parseInt(btn.dataset.step);
          const value = btn.dataset.value;
          selectOption(step, value, btn);
        });
      });

      window.OTWSQuiz = { showResults: showResults };
    }

    function startQuiz() {
      document.getElementById('quiz-intro').style.display = 'none';
      const wrapper = document.getElementById('quiz-wrapper');
      wrapper.style.display = 'block';
      updateProgress(1);
    }

    function selectOption(step, value, btn) {
      document.querySelectorAll(`.skin-quiz__option[data-step="${step}"]`).forEach(function(b) {
        b.classList.remove('selected');
      });
      btn.classList.add('selected');
      state.answers[step] = value;

      setTimeout(function() {
        if (step < state.totalSteps) {
          showStep(step + 1);
        } else {
          showEmailScreen();
        }
      }, 280);
    }

    function showStep(stepNum) {
      for (var i = 1; i <= state.totalSteps; i++) {
        var el = document.getElementById('step-' + i);
        if (el) el.style.display = (i === stepNum) ? 'block' : 'none';
      }
      state.currentStep = stepNum;
      updateProgress(stepNum);

      var prevBtn = document.getElementById('quiz-prev-btn');
      if (prevBtn) prevBtn.style.display = stepNum > 1 ? 'inline-flex' : 'none';

      var label = document.getElementById('quiz-step-label');
      if (label) label.textContent = 'Question ' + stepNum + ' / ' + state.totalSteps;
    }

    function goToPrev() {
      if (state.currentStep > 1) showStep(state.currentStep - 1);
    }

    function updateProgress(step) {
      var pct = ((step - 1) / state.totalSteps) * 100;
      var bar = document.getElementById('quiz-progress-bar');
      if (bar) bar.style.width = pct + '%';
    }

    function showEmailScreen() {
      document.getElementById('quiz-wrapper').style.display = 'none';
      var screen = document.getElementById('quiz-email-screen');
      screen.style.display = 'block';

      var summary = document.getElementById('quiz-email-summary');
      if (summary) {
        var lines = [];
        var labels = {
          1: 'Peau', 2: 'Préoccupation', 3: 'Zone', 4: 'Texture', 5: 'Routine', 6: 'Budget'
        };
        document.querySelectorAll('.skin-quiz__option.selected').forEach(function(opt) {
          var s = parseInt(opt.dataset.step);
          if (labels[s]) lines.push('<strong>' + labels[s] + ' :</strong> ' + opt.querySelector('strong').textContent);
        });
        summary.innerHTML = lines.join(' &nbsp;·&nbsp; ');
      }

      var noteInput = document.getElementById('quiz-klaviyo-note');
      var tagsInput = document.getElementById('quiz-klaviyo-tags');
      if (noteInput) {
        var noteData = [];
        for (var k in state.answers) noteData.push('Q' + k + '=' + state.answers[k]);
        noteInput.value = noteData.join('; ');
      }
      if (tagsInput) {
        var tags = ['quiz-skin-diagnostic'];
        if (state.answers[1]) tags.push('skin-' + state.answers[1]);
        if (state.answers[2]) tags.push('concern-' + state.answers[2]);
        tagsInput.value = tags.join(', ');
      }
    }

    function showResults() {
      document.getElementById('quiz-email-screen').style.display = 'none';
      var results = document.getElementById('quiz-results');
      results.style.display = 'block';

      var profile = getProfile();
      var titleEl = document.getElementById('quiz-results-title');
      var subtitleEl = document.getElementById('quiz-results-subtitle');
      var badgeEl = document.getElementById('quiz-profile-badge');

      if (titleEl) titleEl.textContent = profile.title;
      if (subtitleEl) subtitleEl.textContent = profile.subtitle;
      if (badgeEl) badgeEl.textContent = profile.emoji + '  ' + profile.title;

      filterProducts();
    }

    function filterProducts() {
      var skinVal = state.answers[1] || '';
      var concernVal = state.answers[2] || '';
      var cards = document.querySelectorAll('.skin-quiz__product-card');
      var shown = 0;

      cards.forEach(function(card) {
        var skinTypes = (card.dataset.skinTypes || '').split(',').map(function(s) { return s.trim(); });
        var concerns = (card.dataset.concerns || '').split(',').map(function(s) { return s.trim(); });
        var skinMatch = !skinTypes[0] || skinTypes.includes(skinVal) || skinTypes.includes('all');
        var concernMatch = !concerns[0] || concerns.includes(concernVal) || concerns.includes('all');
        var display = (skinMatch || concernMatch) && shown < 4;
        card.style.display = display ? 'block' : 'none';
        if (display) shown++;
      });

      if (shown === 0) {
        cards.forEach(function(card, i) {
          card.style.display = i < 3 ? 'block' : 'none';
        });
      }
    }

    function addRoutineToCart() {
      var variantIds = [];
      document.querySelectorAll('.skin-quiz__product-card[style*="block"]').forEach(function(card) {
        var vid = card.dataset.variantId;
        if (vid) variantIds.push(vid);
      });

      if (!variantIds.length) {
        window.location.href = '/collections/all';
        return;
      }

      var items = variantIds.map(function(id) { return { id: id, quantity: 1 }; });

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function() {
        window.location.href = '/cart';
      })
      .catch(function() {
        window.location.href = '/cart';
      });
    }

    function restartQuiz() {
      state.currentStep = 1;
      state.answers = {};
      state.emailCaptured = false;

      document.querySelectorAll('.skin-quiz__option').forEach(function(btn) {
        btn.classList.remove('selected');
      });
      document.querySelectorAll('.skin-quiz__step').forEach(function(el, i) {
        el.style.display = i === 0 ? 'block' : 'none';
      });

      document.getElementById('quiz-results').style.display = 'none';
      document.getElementById('quiz-email-screen').style.display = 'none';
      document.getElementById('quiz-intro').style.display = 'flex';

      var bar = document.getElementById('quiz-progress-bar');
      if (bar) bar.style.width = '0%';
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
